import { Component, OnInit } from '@angular/core';
import { NavigationExtras, Router } from '@angular/router';
import { Message } from 'src/app/interfaces/Message';
import { DesktopService } from 'src/app/services/desktop.service';
import { LocalStorageService } from 'src/app/services/local-storage.service';
import { TitleService } from 'src/app/services/title.service';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-messages',
    templateUrl: './messages.page.html',
    styleUrls: ['./messages.page.scss']
})
export class MessagesPageComponent {
    public messages: Message[] = [];

    constructor(private router: Router, private ls: LocalStorageService, private titleService: TitleService, private desktopService: DesktopService) {
        const messages: Message[] = environment.all_messages;
        const date = new Date();

        const foundedNewMessage = messages.find(message => message.new_message === true);

        if (this.ls.getLS('generated_code') !== null && typeof foundedNewMessage === 'undefined') {
            const newMessage: Message = {
                id: 1,
                firstname: 'LVB Media Experience',
                lastname: '',
                image: 'placeholder.png',
                messages: 'Telefoon verificatie code ontvangen',
                date: date.toString(),
                new_message: true,
                conversation: [
                    {
                        person: '',
                        message: ''
                    }
                ]
            };

            messages.push(newMessage);
        }

        const sorted_date = messages.sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime());
        this.messages = sorted_date;

        this.titleService.setTitle('Experience | Messages');
    }

    goToDetails(id: number) {
        const message = this.messages.find(row => row.id === id);

        const navigationExtras: NavigationExtras = {
            state: { message }
        };

        if (this.desktopService.isDesktop()) {
            this.router.navigate([{ outlets: { mobile: ['message-details'] } }], navigationExtras);
        } else {
            this.router.navigate(['message-details'], navigationExtras);
        }
    }
}
